"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var framer_motion_1 = require("framer-motion");
var polished_1 = require("polished");
var Item = styled_components_1["default"](framer_motion_1.motion.li)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        font-family: 'Oswald';\n        min-height: 52px!important;\n        margin: 8px 0;\n        a {\n            text-decoration: none;\n            display: block;\n            color: #fff;\n            cursor: pointer;\n            letter-spacing: 3px;\n\n            &:before {\n                color: #b4a689;\n                content: \"+\";\n                padding-right: 1rem;\n            }\n\n            &:hover {\n                color: ", ";\n            }\n        }\n"], ["\n        font-family: 'Oswald';\n        min-height: 52px!important;\n        margin: 8px 0;\n        a {\n            text-decoration: none;\n            display: block;\n            color: #fff;\n            cursor: pointer;\n            letter-spacing: 3px;\n\n            &:before {\n                color: #b4a689;\n                content: \"+\";\n                padding-right: 1rem;\n            }\n\n            &:hover {\n                color: ", ";\n            }\n        }\n"])), polished_1.lighten(0.2, "#b4a689"));
var itemVariants = {
    open: {
        x: 0,
        opacity: 1,
        transition: {
            x: { stiffness: 1000, velocity: -100 }
        }
    },
    closed: {
        x: -50,
        opacity: 0,
        transition: {
            x: { stiffness: 1000 }
        }
    }
};
exports.NavItem = function (_a) {
    var href = _a.href, name = _a.name, onClick = _a.onClick;
    return (React.createElement(Item, { onClick: onClick, variants: itemVariants },
        React.createElement("a", { href: href }, name)));
};
var templateObject_1;
